/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTimePickerProps, TdTimeRangePickerProps } from './type';

export const timePickerDefaultProps: TdTimePickerProps = {
  allowInput: false,
  borderless: false,
  clearable: false,
  format: 'HH:mm:ss',
  hideDisabledTime: true,
  size: 'medium',
  steps: [1, 1, 1],
};

export const timeRangePickerDefaultProps: TdTimeRangePickerProps = {
  allowInput: false,
  clearable: false,
  format: 'HH:mm:ss',
  hideDisabledTime: true,
  size: 'medium',
  steps: [1, 1, 1],
};
